function getProjectStatusColor(status: number) : spintrColors {
    const colors : spintrColors[] = ["p-green-1", "p-red-1", "p-red-1", "p-green-1", "p-link-color"];

    return colors[status];
}

export default getProjectStatusColor;